import React from 'react';
import { useTranslation } from 'react-i18next';
import Marquee from 'react-fast-marquee';

interface Insurance {
    id: number;
    image: string;
}

interface Props {
    insurance: Insurance[];
}

export default function Insurance({ insurance }: Props) {
    const { t , i18n } = useTranslation();

    return (
        <div className='m-5 py-5 px-8 grid grid-cols-1 gap-2'>
            <div className='flex flex-col items-start'>
                <p className=' text-custom-dark-blue  font-bold text-sm lg:text-base px-4 py-4 mb-2  dark:text-white'>
                    {t('sidebar.insuarance')}
                </p>
            </div>
            <div
            dir='ltr'
            >
                <Marquee
                speed={90}
                delay={0}
                direction={`${i18n.language === 'ar' ? 'left' : 'right'}`}
                >
                    {insurance.length > 0 &&
                        insurance.map((item) => (
                            <div key={item.id} className="mx-5">
                                <img
                                    src={item.image}
                                    alt="insurance-image"
                                    loading='lazy'
                                    className='h-20 xs:h-10'
                                />
                            </div>
                        ))
                    }
                </Marquee>
            </div>
        </div>
    );
}